/**
 * NumberValueSelector Component
 *
 * Provides number input for numeric field types
 *
 * @module FilterEditor/NumberValueSelector
 */

import React from 'react';
import { Input } from '@loader/ui';

import type { ValueSelectorProps } from './types';

export const NumberValueSelector: React.FC<ValueSelectorProps> = ({
  canEdit = true,
  filter,
  selectedField,
  debouncedOnUpdate,
}) => {
  return (
    <Input
      type="number"
      placeholder="Enter value"
      value={filter.value !== null && filter.value !== undefined ? String(filter.value) : ''}
      onChange={(e) => {
        const numValue = e.target.value === '' ? null : Number(e.target.value);
        debouncedOnUpdate({
          ...filter,
          value: numValue,
          field_name: selectedField?.name || filter.field_name,
        });
      }}
      disabled={!filter.field_id || !canEdit}
      className="bg-background w-full"
    />
  );
};
